import React from "react";
import Label from "../../Common/components/Label";

const RepeatSelect = ({
  labelMessage,
  selectId,
  selectValue,
  selectOptions,
  onChange,
}) => {
  return (
    <div className="d-flex align-items-center">
      &nbsp;&nbsp;&nbsp;&nbsp;
      <Label message="Repeated every" fontSize="0.8125" color="#7B7D80" />
      <div className="input-group w-50 border-0 mt-0 max-content-width ms-2">
        <select
          className="fst-normal border-0 form-select shadow-none"
          id={selectId}
          placeholder="1"
          style={{ fontSize: "0.75rem", fontWeight: "600" }}
          value={selectValue}
          onChange={onChange}
        >
          {selectOptions.map((item) => (
            <option
              className="bg-white text-black"
              style={{
                fontFamily: "Noto Sans, sans-serif",
                backgroundColor: "#fff",
              }}
              key={item}
              value={item}
            >
              {item}
            </option>
          ))}
        </select>
      </div>
      &nbsp;&nbsp;
      <Label
        message={`${labelMessage.charAt(0).toUpperCase()}${labelMessage.slice(1).toLowerCase()}`}
        fontSize="0.85"
        color="#7B7D80"
      />
    </div>
  );
};

export default RepeatSelect;
